import {
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@outschool/backpack";
import React from "react";

interface AttributeCheckboxListProps<T extends string> {
  selections: { value: T; label: string }[];
  selectedValues: T[];
  setValues: (values: T[]) => void;
  specialNoneValue?: T;
}
export const AttributeCheckboxList = <T extends string>({
  selections,
  selectedValues,
  setValues,
  specialNoneValue,
}: AttributeCheckboxListProps<T>) => {
  const onClickOption = (clickedOption: T) => {
    // deselect others when "none of the above" is picked
    if (
      !!specialNoneValue &&
      clickedOption === specialNoneValue &&
      !selectedValues.includes(clickedOption)
    ) {
      setValues([specialNoneValue]);
    } else {
      const newValues = selectedValues.includes(clickedOption)
        ? selectedValues.filter(selectedNeed => selectedNeed !== clickedOption)
        : [...selectedValues, clickedOption];
      setValues(newValues);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      {selections.map(option => (
        <FormControlLabel
          key={option.label}
          control={
            <Checkbox
              checked={selectedValues.includes(option.value)}
              onClick={() => onClickOption(option.value)}
              // disable other options when "none of the above" is checked
              disabled={
                !!specialNoneValue &&
                option.value != specialNoneValue &&
                selectedValues.includes(specialNoneValue)
              }
            />
          }
          label={<Typography>{option.label}</Typography>}
        />
      ))}
    </Box>
  );
};
